class Registry {
    constructor() {
        this.objects = {};
    }

    add(key, value) {
        if (typeof key == 'object' && typeof value == 'undefined') {
            for (var index in key) {
                this._add(index, key[index]);
            }
        } else if (typeof key == 'string' && value) {
            this._add(key, value);
        } else {
            throw Error('Cannot add object to Registry, key or value is missing.');
        }
    }

    _add(key, value) {
        if (typeof this.objects[key] != 'undefined') {
            throw Error('Registry object with this key is already set.');
        }

        this.objects[key] = value;
    }

    exists(key) {
        if (typeof this.objects[key] != 'undefined') {
            return true;
        }
        return false;
    }

    remove(key, value) {
        if (typeof this.objects[key] == 'undefined') {
            throw Error('Registry object with this key is not set.');
        }

        delete this.objects[key];
    }

    get(key) {
        if (typeof this.objects[key] == 'undefined') {
            throw Error('Registry object with this key is not set.');
        }

        return this.objects[key];
    }
}

let _instance;

/**
 * @return {Registry}
 */
function getInstance() {
    if (!_instance) {
        _instance = new Registry();
    }

    return _instance;
}

export default getInstance();


// WEBPACK FOOTER //
// ./src/registry/index.js